import * as React from 'react';
import EditProfilePage from '../containers/EditProfilePage';

export default (props) => <EditProfilePage {...props} />

